import { computed } from 'vue'
import { useStore } from 'vuex'
import { mapGetters, mapActions } from 'vuex'

export const useMapper = (mapper, mapFn, namespace, map) => {
  const store = useStore()

  const mappedFns = mapper(namespace, map)
  
  const result = {}
  Object.keys(mappedFns).forEach(key => {
    if (mapFn === 'mapGetters') {
      result[key] = computed(() => mappedFns[key].call({ $store: store }))
    } else {
      result[key] = mappedFns[key].bind({ $store: store })
    }
  })
  
  return result
}

export const useGetters = (namespace, getters) => {
  return useMapper(mapGetters, 'mapGetters', namespace, getters)
}

export const useActions = (namespace, actions) => {
  return useMapper(mapActions, 'mapActions', namespace, actions)
}